import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// mui
import { Box } from '@mui/material';
// component
import Loading from '../mui/Backdrop';
import SendBtn from './SendBtn';
import ComfirmSend from '@/component/send/ComfirmSend';
import { useChainId } from 'wagmi';
// hook
import { useWeb3 } from '@/hooks/use-web3';
// lib & store
import { useSendInfo } from '@/store/zustand/store';
import { telegramForm } from '@/lib/error-bot/telegram';
import { sleep, cutCommas } from '@/lib/util';
import { ethToWei } from '@/lib/web3/utils';
import { explorerUrlFilter } from '@/filter/explorerUrl';

export default function BaseCoin({ symbol }: { symbol: string }) {
  const navigate = useNavigate();
  const sendInfo = useSendInfo();
  const [isSubmit, setIsSubmit] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const { web3authCall } = useWeb3();
  const txhash = useRef('');
  const [typeLogin, setTypeLogin] = useState('');
  const currentChainId = useChainId();

  (async () => {
    sleep(1000);
  })();
  useEffect(() => {
    if (isSubmit && web3authCall?.connected()) {
      (async () => {
        console.log(`BaseCoin`);
        try {
          console.log(`sendInfo.value`);
          console.log(sendInfo.value);
          const re = await web3authCall.getRpc().signAndSendTransaction(sendInfo.to, ethToWei(cutCommas(sendInfo.value)));
          // 트랜잭션 해시가 나옴
          console.log(re);
          txhash.current = re;
          setIsSuccess(true);
        } catch (e) {
          const text = `type: baseCoin_useSendTransaction(), fromAddr: ${sendInfo.from}, toAddr: ${sendInfo.to}, value: ${sendInfo.value}, meg: ${JSON.stringify(e)}`;
          telegramForm(text);
          navigate('/sendFail', {
            state: {
              data: '전송 실패',
            },
          });
          setIsSubmit(false);
        }
      })();
    }
    return () => {};
  }, [isSubmit]);

  // const { config } = usePrepareSendTransaction({
  //   // data: `0x${contract}`,
  //   to: sendInfo.to,
  //   value: parseEther(`${sendInfo.value}`), // parseEther('0.01'),
  // });
  // const { data: sendData, isLoading, isSuccess, isError, error, sendTransaction } = useSendTransaction(config);

  // useEffect(() => {
  //   console.log(`isSubmit: ${isSubmit}`);
  //   if (isSubmit) {
  //     sendTransaction?.();
  //   }
  //   return () => {};
  // }, [isSubmit, sendTransaction]);

  // useEffect(() => {
  //   if (isError) {
  //     const text = `type: baseCoin_useSendTransaction(), fromAddr: ${sendInfo.from}, toAddr: ${sendInfo.to}, value: ${sendInfo.value}, meg: ${error?.message}, etc: ${sendData}`;
  //     telegramForm(text);
  //     navigate('/sendFail', {
  //       state: {
  //         data: error?.message,
  //       },
  //     });
  //   }
  //   return () => {};

  // }, [isError]);

  useEffect(() => {
    if (isSuccess) {
      navigate('/sendSuccess', {
        state: {
          type: 'base',
          data: { hash: txhash.current, blockExplorerUrl: explorerUrlFilter(currentChainId) },
        },
      });
    }
    return () => {};
  }, [isSuccess]);

  return (
    <>
      <ComfirmSend type="base" symbol={symbol} />
      {isSubmit && (
        <>
          {typeLogin === 'external' ? (
            <Loading
              isLoading={isSubmit}
              text="사용할 전자지갑에서 전송 승인 완료 후 셔플을 실행하여 전송결과를 확인하세요."
            />
          ) : (
            <Loading isLoading={isSubmit} />
          )}
        </>
      )}
      <Box mb={5} />
      {/* <Box position="relative" bottom={0} left={0} width="100%">
        <Container maxWidth="sm">
          <Stack direction="row" gap={1} mb={3}>
            <Button
              variant="contained"
              size="large"
              fullWidth
              type="submit"
              onClick={() => {
                setIsSubmit(true);
                const re = localGetStorage('snsAddress') || false;
                setTypeLogin(re.typeOfLogin);
              }}
            >
              보내기
            </Button>
          </Stack>
        </Container>
      </Box> */}
      <SendBtn setIsSubmit={setIsSubmit} setTypeLogin={setTypeLogin} />
    </>
  );
}
